import React from "react";

const TermsOfService: React.FC = () => {

    document.title = "Terms of Service | Zulu Courier ";
    return(
        <>
            <div className="container">
                <section className="my-4">
                    <div className="position-relative">
                        <div className="row g-5 w-100 mt-5">
                            <div className="col-lg-12">
                                {/* <a href="/signup">Back to Sign Up</a> */}
                            </div>
                        </div>
                        <div className="row g-5 w-100 mb-4 mt-2">
                            <div className="col-lg-12">
                                <h2>Zulu Courier Inc. — Terms of Service</h2>
                                <p className="text-muted"><strong>Last Updated: November 2025</strong></p>
                                <p>These Terms of Service ("Terms") govern the use of the Zulu Courier Inc. website, mobile application, software, and delivery services (collectively, the "Platform"). By placing an order or accessing the Platform, you agree to these Terms. If you do not agree, you must stop using the Platform immediately.</p>
                            </div>
                        </div>
                        <div className="row g-5 w-100">
                            <div className="col-lg-12">
                                
                                <h4>1. Service Overview</h4>
                                <p>Zulu Courier Inc. ("Zulu", "we", "us", "our") provides same-day and scheduled delivery services across Toronto and surrounding cities within Ontario.</p>
                                <p>Zulu connects customers ("you") with independent delivery contractors ("Drivers") who complete pickups and deliveries.</p>
                                <p>Delivery timelines are <strong>estimates</strong>, and may be impacted by traffic, weather, road closures, and other factors outside our control.</p>

                                <h4 className="mt-4">2. Orders & Customer Responsibilities</h4>
                                <p>You agree to:</p>
                                <ul>
                                    <li>Provide accurate pickup and delivery details</li>
                                    <li>Include buzzer codes, access notes, or special instructions</li>
                                    <li>Ensure packages are ready at the scheduled pickup time</li>
                                    <li>Ensure delivery location access is available</li>
                                </ul>
                                <p>Zulu is not responsible for delays or failed delivery attempts caused by incorrect or missing information.</p>

                                <h4 className="mt-4">3. Packaging & Labeling</h4>
                                <p>You are fully responsible for:</p>
                                <ul>
                                    <li>Proper packaging suited for transportation</li>
                                    <li>Secure sealing and accurate labeling</li>
                                    <li>Identifying fragile or sensitive items visibly</li>
                                </ul>
                                <p>Zulu may refuse poorly packaged or unsafe shipments.</p>
                                <p>Zulu is <strong>not liable</strong> for damage caused by insufficient packaging.</p>

                                <h4 className="mt-4">4. Delivery Completion & Proof of Delivery</h4>
                                <p>A delivery is considered completed when <strong>any valid proof of delivery is recorded, including but not limited to</strong>:</p>
                                <ul>
                                    <li>Recipient name confirmation</li>
                                    <li>Photo proof taken at the delivery location</li>
                                    <li>PIN verification (if selected at booking)</li>
                                </ul>
                                <p>Once proof of delivery is recorded:</p>
                                <ul>
                                    <li>The delivery status will be updated in the Zulu Courier portal or app</li>
                                    <li>Responsibility for the shipment transfers to the customer or recipient</li>
                                </ul>

                                <h4 className="mt-4">5. Re-Delivery, Returns, Incorrect Addresses & Failed Pickups</h4>
                                <p>If delivery cannot be completed due to:</p>
                                <ul>
                                    <li>Incorrect or incomplete address</li>
                                    <li>Receiver unavailable</li>
                                    <li>No safe delivery option</li>
                                </ul>
                                <p>Zulu will attempt to contact the customer.</p>
                                <p>You may request:</p>
                                <ul>
                                    <li>Re-delivery</li>
                                    <li>Return to sender</li>
                                </ul>
                                <p>➡️ A <strong>second delivery fee</strong> applies.</p>
                                <p>Zulu may securely hold packages temporarily if next instructions are unclear.</p>
                                <p>If a pickup cannot be completed because:</p>
                                <ul>
                                    <li>The shipment is not ready</li>
                                    <li>The sender or contact person is unavailable</li>
                                    <li>Access to the pickup location is not provided</li>
                                    <li>Packaging requirements are not met</li>
                                </ul>
                                <p>➡️ The order may be marked as a <strong>Failed Pickup</strong>, and a <strong>failed pickup fee may apply</strong>.</p>

                                <h4 className="mt-4">6. Prohibited Items</h4>
                                <p>The following <strong>cannot</strong> be shipped:</p>
                                <ul>
                                    <li>Cash, negotiable currency, high-value gift cards</li>
                                    <li>Illegal substances, stolen goods, contraband</li>
                                    <li>Weapons, ammunition, explosives</li>
                                    <li>Hazardous, flammable, or toxic materials</li>
                                    <li>Medical waste, infectious substances, biohazards</li>
                                    <li>Live animals or human remains</li>
                                </ul>
                                <p>Zulu may refuse any shipment or notify authorities if needed.</p>

                                <h4 className="mt-4">7. Sensitive, Fragile & Perishable Goods</h4>
                                <ul>
                                    <li>Must be packaged to withstand transit</li>
                                    <li>Must be labeled clearly</li>
                                </ul>
                                <p>Zulu will handle such items responsibly, however:</p>
                                <ul>
                                    <li><strong>Liability is case-by-case</strong></li>
                                    <li>Claims require internal review</li>
                                    <li>Spoilage due to delays, weather, or required temperature control is <strong>not</strong> covered</li>
                                </ul>
                                <p>Insurance options <strong>must</strong> be requested in advance if needed.</p>

                                <h4 className="mt-4">8. Pricing & Payment</h4>
                                <p>Pricing depends on:</p>
                                <ul>
                                    <li>Distance</li>
                                    <li>Vehicle type</li>
                                    <li>Shipment size, weight, and service level</li>
                                </ul>
                                <p><strong>Payment is due at booking unless otherwise approved by Zulu Courier Inc.</strong></p>
                                <p>Verified businesses may qualify for monthly invoicing after review and approval by Zulu Courier Inc.</p>
                                <ul>
                                    <li>Payment due upon receipt of invoice</li>
                                    <li>A maximum payment period applies as agreed</li>
                                    <li>Overdue balances may result in suspended service or account review</li>
                                </ul>

                                <h4 className="mt-4">9. Liability & Claims</h4>
                                <p>Zulu Courier Inc. takes reasonable care in transporting shipments. However:</p>
                                <p><strong>Zulu Courier Inc's maximum liability is limited to a refund of the delivery fee only, and only if the claim is reviewed and approved by Zulu Courier Inc.</strong></p>
                                <p>In certain cases, following internal review and approval, Zulu Courier Inc. may provide reimbursement for the documented replacement value of the affected shipment, up to a maximum of $200 CAD, strictly case by case and at the sole discretion of Zulu Courier Inc.</p>
                                <p>To be eligible for review, claims must be submitted within 24 hours of delivery completion and include:</p>
                                <ul>
                                    <li>Order number</li>
                                    <li>Photos clearly showing the issue</li>
                                    <li>Description of the concern</li>
                                    <li>Documented replacement value (if applicable)</li>
                                </ul>
                                <p>Zulu Courier Inc. does not accept liability for:</p>
                                <ul>
                                    <li>Damage caused by insufficient or improper packaging</li>
                                    <li>Concealed damage discovered later</li>
                                    <li>Delay due to traffic, weather, safety, or other factors outside our control</li>
                                    <li>Wrong or incomplete addresses provided by the customer</li>
                                    <li>Items that are prohibited or restricted under these Terms</li>
                                </ul>
                                <p><strong>All decisions made through Zulu Courier Inc's internal review are final.</strong></p>

                                <h4 className="mt-4">10. Independent Contractor Drivers</h4>
                                <p>Drivers are <strong>independent contractors</strong>, not employees of Zulu Courier Inc.</p>
                                <p>Drivers are responsible for their own conduct when not actively performing assigned deliveries.</p>

                                <h4 className="mt-4">11. Tracking & Communications</h4>
                                <p>Tracking may be available depending on service type.</p>
                                <p>Accuracy may vary due to driver device performance, mobile signal, or GPS availability.</p>
                                <p>You consent to receive:</p>
                                <ul>
                                    <li>SMS updates</li>
                                    <li>Phone calls when needed</li>
                                    <li>App and email notifications</li>
                                </ul>

                                <h4 className="mt-4">12. Suspension or Termination</h4>
                                <p>Zulu Courier Inc. may suspend or terminate access to the Platform if:</p>
                                <ul>
                                    <li>Terms are violated</li>
                                    <li>Unsafe, harmful, abusive, or unlawful behavior occurs</li>
                                    <li>Fees remain unpaid</li>
                                </ul>
                                <p>You may stop using the Platform at any time.</p>

                                <h4 className="mt-4">13. Intellectual Property</h4>
                                <p>All Platform content, branding, software, and trademarks belong to Zulu Courier Inc. and may not be copied, reproduced, or reused without written approval.</p>

                                <h4 className="mt-4">14. Privacy</h4>
                                <p>We collect only the information needed to complete and improve delivery services.</p>
                                <p>Full details are available in our <strong>Privacy Policy</strong>.</p>

                                <h4 className="mt-4">15. Governing Law</h4>
                                <p>These Terms are governed by the laws of <strong>Ontario, Canada</strong>.</p>
                                <p>All disputes must be resolved in the courts of <strong>Toronto, Ontario</strong>.</p>

                                <h4 className="mt-4">16. Updates to Terms</h4>
                                <p>Zulu Courier Inc. may modify these Terms at any time.</p>
                                <p>Continued use of our Platform or Services constitutes acceptance of the latest version.</p>

                                <h4 className="mt-4">17. Location Data</h4>
                                <p>The Zulu - Pickup & Delivery app collects and uses location data to enable key delivery features, including showing accurate driver location, providing real-time ETAs, and improving routing efficiency. </p>
                                <p>Location data may be collected while the app is open, running in the background, or when a delivery is active. This information is only used for operational purposes related to pickups, deliveries, and safety. </p>
                                <p>By using the Zulu app, users consent to the collection and use of their location information as described. </p>
                                <p>Location data is not sold or shared with third parties except as required to complete deliveries or comply with legal obligations. </p>

                                <h4 className="mt-4">Contact</h4>
                                <p>
                                    <strong>Zulu Courier Inc.</strong><br />
                                    📍 Toronto, Ontario, Canada<br />
                                    📧 support@zulucourier.com
                                </p>
                                
                                <p className="mt-4 text-muted">
                                    <small>© Zulu Courier Inc. All rights reserved.</small>
                                </p>

                                <p className="mt-5">
                                    By engaging our courier services, you acknowledge that you agree with the above terms and conditions.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}

export default TermsOfService;